/** 支付费用相关接口 */
import request from '@/utils/util.request';

/*
 *  (devfee) 设备续期 加载页面数据
 */
export const devfee_load_data = (data) => {
	return request({
		url: '/devfee/loaddata',
		data,
	});
};

/*
 *  (devfee) 设备续期 发起微信支付
 *  @param {int} product: 续期种类的id值
 *  @param {int} amount: 金额(分)
 */
export const devfee_pay = (data) => {
	return request({
		url: '/devfee/pay',
		data,
	});
};
